import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ClientRequest, KeycloakAdminApi } from '../../services/keycloak-admin-api';
import { ClientRequestCard } from '../client-request-card/client-request-card';
import { LoadStatus } from '../load-status/load-status';

@Component({
  selector: 'app-my-client-requests',
  imports: [RouterLink, ClientRequestCard, LoadStatus],
  templateUrl: './my-client-requests.html',
  styleUrl: './my-client-requests.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyClientRequests implements OnInit {
  private keycloakApi = inject(KeycloakAdminApi);

  requests = signal<ClientRequest[]>([]);
  isLoading = signal(true);
  loadError = signal<string | null>(null);

  async ngOnInit(): Promise<void> {
    await this.loadRequests();
  }

  private async loadRequests(): Promise<void> {
    this.isLoading.set(true);
    this.loadError.set(null);
    try {
      const requests = await this.keycloakApi.getMyClientRequests();
      this.requests.set([...requests].sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
    } catch (error) {
      this.loadError.set(
        error instanceof Error ? error.message : 'Failed to load your client requests'
      );
    } finally {
      this.isLoading.set(false);
    }
  }
}
